import {
  Button,
  createStyles,
  ListItem,
  makeStyles,
  Theme,
} from '@material-ui/core'
import { useLocation, useNavigate } from 'react-router-dom'

type SettingsItemProps = {
  title: string
  level?: number
  to?: string
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: (props: { level: number; isActive: boolean }) => ({
      paddingLeft: `${theme.spacing(2) * props.level}px`,
      textAlign: 'left',
      justifyContent: 'flex-start',
      backgroundColor: props.isActive ? theme.palette.info.main : 'transparent',
      color: props.isActive
        ? theme.palette.info.contrastText
        : theme.palette.type === 'dark'
        ? theme.palette.text.primary
        : theme.palette.primary.main,
      '&:hover': {
        backgroundColor: props.isActive
          ? theme.palette.info.dark
          : theme.palette.action.hover,
      },
    }),
  })
)

export const SettingsItem = (props: SettingsItemProps) => {
  const location = useLocation()
  const isActive = location.pathname === props.to
  const cn = useStyles({ level: props.level, isActive })
  const navigate = useNavigate()

  return (
    <ListItem disableGutters onClick={() => navigate(props.to)}>
      <Button disableRipple className={cn.root} fullWidth color="primary">
        {props.title}
      </Button>
    </ListItem>
  )
}
